import { Container, Row, Col} from 'react-bootstrap';
//import { FaInstagram } from "react-icons/fa6";
import {FaWhatsapp ,FaLinkedin } from "react-icons/fa";
import '../styles/footer.css';

function Footer() {
    return(
        <footer className="footer text-white py-4">
        <Container>
          <Row>
            <Col md={6}>
              <h5>Contact Us</h5>
              <br/>
              <h6>Chat to us</h6>
              <a className="footer-link" href="mailto:info@qplusmc.com"><p>info@qplusmc.com</p></a>
              
              <h6>Call us</h6>
              <a className="footer-link" href="tel:+971556197770">+971 55 619 7770</a><br/>
              <a  className="footer-link" href="tel:+971556127770">+971 55 612 7770</a>
              <br/><br/>
              <h6>Address</h6>
              <p>Q Plus Management Consultancy (FZC)<br/>Sharjah Research Technology and Innovation Park, Sharjah, UAE</p>
              
              <div className="d-flex soc-icons gap-3">
                <a href="https://wa.me/971556197770?text=Hello%2C%20I%20am%20interested%20in%20your%20accounting%20services%20at%20Qplus%20Management%20Consultancy.%20Please%20share%20more%20details"><i className="bi bi-linkedin"><FaWhatsapp/></i></a>
                <a href="https://www.linkedin.com/in/q-plus-management-consultancy-b8b149374/"><i className="bi bi-linkedin"><FaLinkedin /></i></a>
              </div>
            </Col>
            <Col md={6} className="footer-services-col">
              <a href="/services" style={{"textDecoration":"none","color":"white"}}><h5>Services</h5></a>
              
              <ul className="list-unstyled footer-services">
                 <a href="/service/dataanalyticsandbi" style={{"textDecoration":"none","color":"white"}}><li>Data Analytics & Business Intelligence</li></a>
                 <a href="/service/accountingandbookkeeping" style={{"textDecoration":"none","color":"white"}}><li>Accounting & Bookkeeping Services</li></a>
                <a href="/service/vatandcorporatetax" style={{"textDecoration":"none","color":"white"}}><li>VAT & Corporate Tax Compliance</li></a>
                <a href="/service/amlcompliance" style={{"textDecoration":"none","color":"white"}}><li>AML & Compliance Services</li></a>
                <a href="/service/cfosupport" style={{"textDecoration":"none","color":"white"}}><li>CFO Support Services</li></a>
                <a href="/service/payroll" style={{"textDecoration":"none","color":"white"}}><li>Payroll Management</li></a>
                <a href="/service/interalaudit" style={{"textDecoration":"none","color":"white"}}><li>Internal Audit Services</li></a>
                <a href="/service/auditliaison" style={{"textDecoration":"none","color":"white"}}><li>Audit Liaison & Final Reports</li></a>
              </ul>
            </Col>
            {/* <Col md={4}>
               <div className="map-box-1" >
              <div id="embed-map-display" className="map-box-2" >
                <iframe className="map-box-frame" title="mapframe" frameborder="0" src="https://www.google.com/maps/embed/v1/place?q=sharjah+technology+and&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"></iframe>
              </div>
              </div>
            </Col> */}
          </Row>
          <center>
            <em style={{"color":"gray"}}>© 2025 QPlus Management Consultancy, UAE. All rights reserved</em><br/>
           
          </center>
        </Container>
      </footer>
    )
}

export default Footer;